<template>
  <v-container fluid class="bg-gray-100 h-screen">
    <v-row justify="center" class="py-12">
      <v-col cols="12" md="8">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">
              Request for Scanned Documents
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">
              Choose the document/s for request
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 3" step="3">
              Submit your request
            </v-stepper-step>

            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12" :height="H">
                <div
                  class="
                    flex
                    w-full
                    h-full
                    justify-center
                    items-center
                    text-2xl
                  "
                >
                  {{ menus[0].title }}
                </div>
              </v-card>

              <v-btn color="primary" @click="e1 = 2"> Continue</v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12" :height="H">
                <Documents
                  @onFinalSelectedDocs="onFinalSelectedDocs"
                  @cancelRequest="cancelRequest"
                />
              </v-card>

              <!-- <v-btn color="primary" @click="onPressChoose"> Continue 2 </v-btn> -->

              <!-- <v-btn text @click="e1 = 1"> Cancel </v-btn> -->
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12" color="grey lighten-1" :height="H">
                <div class="text-center p-20 dia_bg">
                  <h1 class="text-xl font-bold">
                    Your request for documents have been received.
                  </h1>
                  <div>
                    Your requested documents will be sent to you via email. You
                    may see the status of your request on your Dashboard. If you
                    would like to claim documents at our head office, you will
                    need to request to Book an Appointment.
                  </div>
                </div>
              </v-card>

              <v-btn color="primary" @click="e1 = 1">Back to Home Page </v-btn>

              <v-btn text @click="goToCustomerDashboard">
                Go to Dashboard
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import Back from "../../common/BackButton.vue";
import Documents from "./RequestDocumentScreen/index.vue";
// import axios from "axios";
export default {
  data() {
    return {
      e1: 1,
      H: "320px",
      menus: [
        {
          title: "Request for Scanned Documents",
          name: "Request for Documents",
          id: 1,
          route: "requestForDocuments",
        },
        {
          title: "Submit Documents",
          name: "Submit Documents",
          id: 2,
          route: "submitDocuments",
        },
      ],
    };
  },
  components: { Documents },
  methods: {
    goToCustomerDashboard() {
      this.$router.push({
        name: "Customer Dashboard",
        query: {
          cc: this.$route.query.cc,
          cn: this.$route.query.cn,
        },
      });
    },
    cancelRequest() {
      this.e1 = 1;
    },
    onFinalSelectedDocs() {
      this.e1 = 3;
    },
    onPressBack() {
      this.$router.push({ name: "Home Dashboard" });
    },
    route(item) {
      if (item.route == "submitDocuments") {
        alert("Under Construction");
      } else {
        this.$router.push({
          name: item.name,
          query: {
            cc: this.$route.query.cc,
            cn: this.$route.query.cn,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.bg_color_btn {
  background: #2f4f4f;
  background-image: linear-gradient(-10deg, #163982, #163982);
}
.bg_color_btn:hover {
  background: linear-gradient(-10deg, #7e1e06, #e97e04);
}
</style>
